import { PageTemplate, HeaderTemplate } from "../styles";
import { useLocation } from "react-router-dom";
import { getCustomerOrder } from "../api/order";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Refund } from "../styles";
import { convertDate, renderSizeAbbreviationHTML } from "../utils";
import { ASSET_URL } from "../constants";

const ReturnConfirmation = () => {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber;
  const orderEmail = state?.orderEmail;

  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getCustomerOrder(orderNumber, orderEmail);
        setOrder(result);
      } catch (error) {
        console.error(error.message);
        toast.error(error.message);
      }
    };
    orderNumber && fetchData();
  }, []);

  let returnTotal = 0;

  const renderReturns = () => {
    return order.returns.map((returnObj) => {
      returnTotal = returnTotal + returnObj.refundAmount;
      return <Refund>{renderProducts(returnObj)}</Refund>;
    });
  };

  const renderProducts = (returnObj) => {
    const filteredProducts = returnObj.products.filter((product) => {
      return product.returnType !== "Keep";
    });
    const products = filteredProducts.map((product) => {
      return (
        <div className="return-product" key={product.itemId}>
          <div className="products-view-image product-image border">
            <picture>
              <source srcset={`${ASSET_URL}/designs/small/${product.design}-logo.avif`} type="image/avif" />
              <img src={`${ASSET_URL}/designs/small/${product.design}-logo.gif`} width="110" />
            </picture>
          </div>
          <div className="products-view-details">
            <div>
              <div>
                <span>Return Type</span>
                <strong>{product.returnType}</strong>
              </div>
              <div className="return-details-margin-top">
                <span>Original Size</span>
                <strong className="size-badge" dangerouslySetInnerHTML={{ __html: renderSizeAbbreviationHTML(product.size) }} />
              </div>
              <div>
                <span>Original Position</span>
                <strong>{product.position}</strong>
              </div>
            </div>
            <div>
              {product.returnType === "Refund" ? (
                <div className="return-details-margin-top">
                  <span>Item Cost</span>
                  <strong>${product.productCost}</strong>
                </div>
              ) : (
                <>
                  <div className="return-details-margin-top">
                    <span>Exchange Size</span>
                    <strong className="size-badge" dangerouslySetInnerHTML={{ __html: renderSizeAbbreviationHTML(product.sizeExchange) }} />
                  </div>
                  <div>
                    <span>Exchange Position</span>
                    <strong>{product.positionExchange}</strong>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      );
    });
    return (
      <>
        <div className="return-products">{products}</div>
        <div className="return-details">
          <div>
            Return Date
            <br />
            <span>{convertDate(returnObj.createdAt)}</span>
          </div>
          {returnObj.totalSalesTaxRefund > 0 && (
            <div>
              + Sales Tax Refund
              <br />
              <span>${returnObj.totalSalesTaxRefund.toFixed(2)}</span>
            </div>
          )}
          {returnObj.shippingFee > 0 && (
            <div>
              - Return Shipping Fee
              <br />
              <span>${returnObj.shippingFee.toFixed(2)}</span>
            </div>
          )}
          {returnObj.refundAmount > 0 && (
            <div>
              = Refund Amount
              <br />
              <span>${returnObj.refundAmount.toFixed(2)}</span>
            </div>
          )}
        </div>
      </>
    );
  };

  if (!orderNumber || !order) return null;

  return (
    <>
      <HeaderTemplate className="narrow">
        <div className="header flex-header">
          <div className="title">
            <h1>Return Confirmation</h1>
          </div>
        </div>
      </HeaderTemplate>
      <PageTemplate className="narrow">
        <div className="return-confirmation-title box-padding-2030">
          <h2>Order # {orderNumber}</h2>
          <p>Your return will be processed shortly. You will receive a return label via email within 24 hours.</p>
        </div>

        <div>{renderReturns()}</div>
        {returnTotal > 0 && (
          <>
            <div className="return-bottom-bar">
              <span className="text">Total Refund Amount for this Order</span>
              <span className="amount">${returnTotal.toFixed(2)}</span>
            </div>
            <p style={{ marginTop: "20px", fontStyle: "italic", padding: "0 20px", textAlign: "center" }}>
              <strong>1 Free Return Per Order</strong>
              <br />
              One free return allowed per order. Additional returns are subject to a shipping fee.
            </p>
          </>
        )}
      </PageTemplate>
    </>
  );
};

export default ReturnConfirmation;
